import { OnInit, Input } from '@angular/core';
import { UIWorkFieldModel, UIPropertyModel } from 'e5core-angular-services';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../models/work-item';
import { FormControl, Validators } from '@angular/forms';

export class E5coreUiWorkFieldTypeComponentBase {

    @Input() workItem$: BehaviorSubject<WorkItemModel>;
    @Input('field') field: UIWorkFieldModel;
    @Input('property') property: UIPropertyModel;
    @Input() readonly: boolean;


    public get propertyId(): string {
        return (this.property) ? this.property.propertyId : '';
    }

    public get label(): string {
        if (this.property) {
            return this.property.label || this.property.placeholder || this.property.propertyId;
        }
        return ('');
    }

    public get description(): string {
        let text = '';
        if (this.field) {
            text = this.field.description;
        }
        return (text || '');
    }

    public get placeholder(): string {
        let text = '';
        if (this.property && !text) {
            text = this.property.placeholder;
        }
        return (text || '');
    }

    // You can override the readonly flag on all fields
    public get isReadOnly(): boolean {
        return (this.readonly || (this.field && this.field.isReadOnly));
    }

    public updatePropertyValueOnChange(formControl:FormControl) {
        this.workItem$.subscribe(
            wi => {
                let newProp = wi.properties.find(p => p.propertyId == this.propertyId) ;
                if(newProp && (newProp.resolvedValue !== formControl.value))  {
                    formControl.setValue(newProp.resolvedValue) ;
                }
            }
        )
    }
}
